var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPublishedPublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visibility_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/action/visibility_24px",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 3.75C5.83333 3.75 2.27499 6.34167 0.833328 10C2.27499 13.6583 5.83333 16.25 9.99999 16.25C14.1667 16.25 17.725 13.6583 19.1667 10C17.725 6.34167 14.1667 3.75 9.99999 3.75ZM9.99997 5.41667C13.1583 5.41667 15.975 7.19167 17.35 10C15.975 12.8083 13.1583 14.5833 9.99997 14.5833C6.84163 14.5833 4.02497 12.8083 2.64997 10C4.02497 7.19167 6.84163 5.41667 9.99997 5.41667ZM6.24999 10C6.24999 7.93333 7.93333 6.25 9.99999 6.25C12.0667 6.25 13.75 7.93333 13.75 10C13.75 12.0667 12.0667 13.75 9.99999 13.75C7.93333 13.75 6.24999 12.0667 6.24999 10Z",
    fill: "#334D6E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublishedPublic);
export default __webpack_public_path__ + "static/media/icon-published-public.68e8e5bd863f9329bedaa1c460b9fcde.svg";
export { ForwardRef as ReactComponent };